import { IGlobalState } from '../../../Root/store/appReducer'

export const getAnnouncementsList = (state: IGlobalState) => state.announcements.list
export const getAnnouncementsFilters = (state: IGlobalState) => state.announcements.filters
export const getAnnouncementsLoading = (state: IGlobalState) => state.announcements.isLoading
export const getAnnouncementsLastUpdate = (state: IGlobalState) => state.announcements.lastUpdate
